export default __webpack_public_path__ + "static/media/ruler-arrow.ca309ded.svg";